import React from "react";
import { Button, Input, Modal } from "@arco-design/web-react";
import { isBlank } from "../utils/validators";

// Create-sequence dialog (render-prop, like BroadcastDialog). Name required.
export default function SequenceDialog({ render, onSave }) {
  const [open, setOpen] = React.useState(false);
  const [name, setName] = React.useState("");
  const [description, setDescription] = React.useState("");

  const handleOpen = () => {
    setOpen(true);
    setName("");
    setDescription("");
  };
  const handleClose = () => setOpen(false);

  const isValid = !isBlank(name);

  const handleSave = () => {
    if (!isValid) {
      return;
    }
    onSave && onSave({ name, description });
    handleClose();
  };

  return (
    <>
      {render(handleOpen)}
      <Modal
        visible={open}
        onCancel={handleClose}
        title="New Sequence"
        footer={
          <>
            <Button onClick={handleClose} type="text">
              Cancel
            </Button>
            <Button onClick={handleSave} type="primary" disabled={!isValid}>
              Create
            </Button>
          </>
        }
      >
        <div style={{ marginBottom: 4 }}>Name</div>
        <Input autoFocus value={name} onChange={(v) => setName(v)} placeholder="Welcome series" />
        <div style={{ marginTop: 16, marginBottom: 4 }}>Description</div>
        <Input value={description} onChange={(v) => setDescription(v)} />
      </Modal>
    </>
  );
}
